var _rect, _rect2, _path, _rect3, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OTP sms"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-703 -413)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "container"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-219 -179.5C-219 -188.337 -211.837 -195.5 -203 -195.5H236C244.837 -195.5 252 -188.337 252 -179.5V376.5C252 385.337 244.837 392.5 236 392.5H-203C-211.837 392.5 -219 385.337 -219 376.5V-179.5Z",
    fill: "#F6F9FB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "container_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social icons light"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social icons"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 6.4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77467 0.515844C7.06103 0.541212 6.14126 0.597044 5.72321 0.681421C5.08507 0.810287 4.48243 1.00567 3.98127 1.2611C3.39243 1.56119 2.86469 1.94407 2.409 2.39904C1.95227 2.8549 1.56786 3.38313 1.26657 3.97285C1.01185 4.47133 0.816578 5.0703 0.687164 5.70482C0.601088 6.12709 0.544161 7.05371 0.518355 7.77196C0.50789 8.06552 0.50252 8.44544 0.50252 8.62066L0.5 24.3771C0.5 24.5516 0.505315 24.9316 0.515725 25.2255C0.541093 25.9391 0.596924 26.8588 0.681356 27.2769C0.810168 27.915 1.0056 28.5177 1.26098 29.0188C1.56112 29.6077 1.94394 30.1354 2.39892 30.5911C2.85478 31.0478 3.38307 31.4322 3.97272 31.7335C4.47126 31.9882 5.07022 32.1835 5.70469 32.313C6.12696 32.399 7.05363 32.456 7.77188 32.4817C8.06534 32.4922 8.44531 32.4976 8.62053 32.4976L24.3769 32.5001C24.5515 32.5001 24.9315 32.4949 25.2253 32.4844C25.9389 32.459 26.8587 32.4032 27.2767 32.3188C27.9149 32.1899 28.5176 31.9945 29.0187 31.7391C29.6075 31.439 30.1353 31.0561 30.5909 30.6012C31.0476 30.1453 31.432 29.6171 31.7334 29.0274C31.988 28.5289 32.1834 27.9299 32.3128 27.2954C32.3989 26.8731 32.4558 25.9464 32.4816 25.2282C32.4921 24.9347 32.4974 24.5548 32.4974 24.3796L32.5 8.62318C32.5 8.44862 32.4947 8.06859 32.4842 7.77475C32.4588 7.06116 32.403 6.14139 32.3186 5.72334C32.1898 5.0852 31.9943 4.48256 31.739 3.98139C31.4389 3.3925 31.0559 2.86482 30.6011 2.40907C30.1452 1.95245 29.6169 1.56799 29.0272 1.26669C28.5287 1.01197 27.9298 0.816645 27.2952 0.687284C26.873 0.60121 25.9463 0.544281 25.2281 0.51853C24.9346 0.507956 24.5546 0.502642 24.3794 0.502642L8.62305 0.500122C8.44848 0.500122 8.06846 0.505379 7.77467 0.515844Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M7.77467 0.515844C7.06103 0.541212 6.14126 0.597044 5.72321 0.681421C5.08507 0.810287 4.48243 1.00567 3.98127 1.2611C3.39243 1.56119 2.86469 1.94407 2.409 2.39904C1.95227 2.8549 1.56786 3.38313 1.26657 3.97285C1.01185 4.47133 0.816578 5.0703 0.687164 5.70482C0.601088 6.12709 0.544161 7.05371 0.518355 7.77196C0.50789 8.06552 0.50252 8.44544 0.50252 8.62066L0.5 24.3771C0.5 24.5516 0.505315 24.9316 0.515725 25.2255C0.541093 25.9391 0.596924 26.8588 0.681356 27.2769C0.810168 27.915 1.0056 28.5177 1.26098 29.0188C1.56112 29.6077 1.94394 30.1354 2.39892 30.5911C2.85478 31.0478 3.38307 31.4322 3.97272 31.7335C4.47126 31.9882 5.07022 32.1835 5.70469 32.313C6.12696 32.399 7.05363 32.456 7.77188 32.4817C8.06534 32.4922 8.44531 32.4976 8.62053 32.4976L24.3769 32.5001C24.5515 32.5001 24.9315 32.4949 25.2253 32.4844C25.9389 32.459 26.8587 32.4032 27.2767 32.3188C27.9149 32.1899 28.5176 31.9945 29.0187 31.7391C29.6075 31.439 30.1353 31.0561 30.5909 30.6012C31.0476 30.1453 31.432 29.6171 31.7334 29.0274C31.988 28.5289 32.1834 27.9299 32.3128 27.2954C32.3989 26.8731 32.4558 25.9464 32.4816 25.2282C32.4921 24.9347 32.4974 24.5548 32.4974 24.3796L32.5 8.62318C32.5 8.44862 32.4947 8.06859 32.4842 7.77475C32.4588 7.06116 32.403 6.14139 32.3186 5.72334C32.1898 5.0852 31.9943 4.48256 31.739 3.98139C31.4389 3.3925 31.0559 2.86482 30.6011 2.40907C30.1452 1.95245 29.6169 1.56799 29.0272 1.26669C28.5287 1.01197 27.9298 0.816645 27.2952 0.687284C26.873 0.60121 25.9463 0.544281 25.2281 0.51853C24.9346 0.507956 24.5546 0.502642 24.3794 0.502642L8.62305 0.500122C8.44848 0.500122 8.06846 0.505379 7.77467 0.515844Z",
    fill: "url(#paint0_linear_0_1)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "message",
    d: "M16.5 25.0555C22.5751 25.0555 27.5 20.9514 27.5 15.8888C27.5 10.8262 22.5751 6.72217 16.5 6.72217C10.4249 6.72217 5.5 10.8262 5.5 15.8888C5.5 19.0978 7.47864 21.9216 10.4747 23.5593C10.3744 24.3743 10.0729 25.4621 9.16667 26.2777C10.8804 25.9693 12.2481 25.3494 13.2697 24.6539C14.2912 24.915 15.3759 25.0555 16.5 25.0555Z",
    fill: "white"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 16.5,
    y1: 32.5001,
    x2: 16.5,
    y2: 0.500122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13BD2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5AF575"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 6.4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpIcn);
export default __webpack_public_path__ + "static/media/otp-icn.272e7475b054cf5720ef807a580d56c1.svg";
export { ForwardRef as ReactComponent };